import storeInit from "storeInit";
import {get, isEmpty} from "lodash";

export default function getWorkshopCurrentPlanSettings(propertyPath){
  const state = storeInit.getState();

  if(isEmpty(state.workshop)){
    return true
  }

  return get(state.workshop.workshopPlan.currentPlanSettings, propertyPath);
}
